import React from 'react';
import OrganizationMembers from 'screens/organizations/components/OrganizationMembers';
import { ManageOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationMembersScreen = () => <OrganizationMembers />;

export default OrganizationMembersScreen;

OrganizationMembersScreen.getLayout = (page) => (
  <ManageOrganizationWrapper>{page}</ManageOrganizationWrapper>
);
